export const PaymentServiceType = {
    CASH: "Cash",
    BANK_TRANSFER: "BankTransfer",
    QR_CODE: "QRCode",
    DOMESTIC_CARD: "DomesticCard",
    INTERNATIONAL_CARD: "InternationalCard"
}